import Dropdown, {
  type DropdownProps,
} from "@booking/components/compounds/forms/Dropdown";
import { DIALING_CODES } from "@booking/consts";
import type { DropdownOptionType } from "@booking/types";
import clsx from "clsx";

import type { CommonProps } from "@/types";
import { createId } from "@/utils/helpers";

import styles from "./DialingCode.module.css";

const ref = "dialing-code";

interface DialingCodeProps
  extends Partial<CommonProps>,
    Pick<DropdownProps, "required"> {
  validityFn?: Function;
  value?: string;
}

function useDialingCode(props: DialingCodeProps) {
  const className = clsx(styles[ref], props.className);
  const id = props.id || createId(ref);
  const options: Array<DropdownOptionType> = Object.entries(DIALING_CODES).map(
    ([key, { prefix }]) => {
      return {
        alt: `${key} ${prefix}`,
        text: prefix,
        value: prefix,
      };
    },
  );
  const value = props.value || DIALING_CODES["United Kingdom"].prefix;

  return {
    className,
    id,
    options,
    required: !!props.required,
    validityFn: props.validityFn,
    value,
  };
}

function DialingCode(props: DialingCodeProps) {
  const { className, id, options, required, validityFn, value } =
    useDialingCode(props);

  return (
    <Dropdown
      className={className}
      custom
      id={id}
      invalid={validityFn && validityFn()}
      label={"Country code"}
      noLabel
      options={options}
      required={required}
      value={value}
    />
  );
}

export default DialingCode;
export { DialingCode, type DialingCodeProps };
